/* 用户信息 */

const state = {

  // 微信登录 appid
  appid:'wxf3264a02ac5f662f', //测试k

  // 用户id,即用户信息主键
  userId: localStorage.getItem("userId"),
  // 用户token
  userToken: localStorage.getItem("userToken"),
  //是否设定密保信息 0-否 1-是
  secretProtectionBind: localStorage.getItem("secretProtectionBind"),
  //是否绑定手机 0-否 1-是
  phoneBind: localStorage.getItem("phoneBind"),
  //是否提供商 false-否 true-是
  isSupplier: localStorage.getItem("isSupplier"),
  //是否律师会员 false-否 true-是
  isMember: localStorage.getItem("isMember"),
  //是否已更改初始密码 0-否 1-是
  initPassword: localStorage.getItem("initPassword"),
  //是否已完善基本信息 0-否 1-是
  infoCompleted: localStorage.getItem("infoCompleted"),
  //是否已绑定邮箱 0-否 1-是
  emailBind: localStorage.getItem("emailBind"),
};

// getters
const getters = {

};

// actions
const actions = {

};

// mutations
const mutations = {
  // 保存用户信息
  saveUserInfo(state, value) {

    if(!value){
      state.userId = null;
      state.userToken = null;
      state.secretProtectionBind = null;
      state.phoneBind = null;
      state.isSupplier = null;
      state.isMember = null;
      state.initPassword = null;
      state.infoCompleted = null;
      state.emailBind = null;

      localStorage.removeItem("userId");
      localStorage.removeItem("userToken");
      localStorage.removeItem("secretProtectionBind");
      localStorage.removeItem("phoneBind");
      localStorage.removeItem("isSupplier");
      localStorage.removeItem("isMember");
      localStorage.removeItem("initPassword");
      localStorage.removeItem("infoCompleted");
      localStorage.removeItem("emailBind");
    }else{
      state.userId = value.userId;
      state.userToken = value.token;
      state.secretProtectionBind = value.secretProtectionBind;
      state.phoneBind = value.phoneBind;
      state.isSupplier = value.isSupplier;
      state.isMember = value.isMember;
      state.initPassword = value.initPassword;
      state.infoCompleted = value.infoCompleted;
      state.emailBind = value.emailBind;

      localStorage.setItem("userId", value.userId);
      localStorage.setItem("userToken", value.token);
      localStorage.setItem("secretProtectionBind", value.secretProtectionBind);
      localStorage.setItem("phoneBind", value.phoneBind);
      localStorage.setItem("isSupplier", value.isSupplier);
      localStorage.setItem("isMember", value.isMember);
      localStorage.setItem("initPassword", value.initPassword);
      localStorage.setItem("infoCompleted", value.infoCompleted);
      localStorage.setItem("emailBind", value.emailBind);
    }

  },
};

export default {
  namespaced: true, // 打开命名空间
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/module/userInfo.js